import React, { Component } from 'react';
import { Card, CardHeader, CardBody, CardFooter, Label, FormGroup } from 'reactstrap';
import { Row, Col, PageHeader, Input, Table, Spin, Select, DatePicker, Button, Tag, Icon, Modal, Divider } from 'antd';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import { urlapi, token, pathimages } from '../../config';
import moment from 'moment';

class TemplateId extends Component {
    constructor(props) {
        super(props);

        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.state = {
            tempId: undefined,
            dropdownlist: [],
            data: []
        }
    }

    componentDidMount() {

    }

    handleSearch(value) {
        if (value) {
            let arr = this.props.dropdownlist.filter(item => item.ltmP_ID.toLowerCase().indexOf(value.toLowerCase()) > -1);
            this.setState({ data: arr })
        } else {
            this.setState({ data: [] });
        }
    };

    handleChange(value) {
        this.setState({ tempId: value });
        this.props.onchange(value)
    };

    render() {
        const { Option } = Select;
        const optionsTempId = this.state.data.map(d => <Option key={d.ltmP_ID}>{d.ltmP_ID}</Option>);
        return (
            <Select
                showSearch
                allowClear
                value={this.state.tempId}
                placeholder="Template ID"
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                onSearch={this.handleSearch}
                onChange={this.handleChange}
                notFoundContent={null}
            >
                {optionsTempId}
            </Select>

        );
    }
}

export default TemplateId;



// WEBPACK FOOTER //
// ./src/views/Dropdown/TemplateId.js